import {
  IAcceptTeamInvitationCodeRequest,
  IConfirmEmailRequest,
  IResetPasswordRequest,
} from "../interfaces-and-types";

interface IConfirmationConstant
  extends Record<string, keyof IConfirmEmailRequest> {}

interface IResetPasswordConstant
  extends Record<string, keyof IResetPasswordRequest> {}

interface IAcceptTeamInvitationConstant
  extends Record<string, keyof IAcceptTeamInvitationCodeRequest> {}

export const accountConfirmationConstants: IConfirmationConstant = {
  confirmationCodeQueryStringName: "code",
  emailQueryStringName: "email",
  merchantIdQueryStringName: "account_id",
};

export const forgotPasswordConstants: IResetPasswordConstant = {
  emailQueryStringName: "email",
  resetPasswordTokenQueryStringName: "reset_password_token",
};

export const acceptTeamInvitationConstants: IAcceptTeamInvitationConstant = {
  invitationCodeQueryStringName: "invitation_code",
};
